<template>
  <b-table
    :class="['gk-table gk-table--responsive gk-table--striped gk-table--hover']"
    :items="existingDocumentList"
    :fields="documentTableFields"
    :busy="loading"
    show-empty
    table-busy
  >
    <template #empty="">
      {{ $gettext('No documents found.') }}
    </template>
    <template #cell(download)="data">
      <GekkoButton 
        @click="downloadDocument(data.item)"
        icon="fa-solid fa-download"
        variant="link" 
        class="text-info"
      />
    </template>
  </b-table>
</template>

<script>

import DocumentService from "@/store/services/document.service";
import GekkoButton from "@/components/GekkoButton"

export default {
  name: "BankDocumentList",
  components: {
    GekkoButton
  },
  props: {
    objectId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      documentTableFields: [
        { key: 'title', label: '' },
        { key: 'download', label: '' }
      ],
      loading: true,
      existingDocumentList: []
    }
  },
  created () {
    this.getDocuments()
  },
  methods: {
    getDocuments () {
      DocumentService.getContentType({ type: 'Correction' }).then((response) => {
        DocumentService.list({ content_type: response.data, object_id: this.objectId }).then((response) => {
          this.existingDocumentList = response.data.results
          this.loading = false
        })
      })
    },
    downloadDocument (item) {
      location.href = window.Urls['documents:download'](item.id)
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
